import { render, staticRenderFns } from "./account_open.vue?vue&type=template&id=3af5c94f&scoped=true&"
import script from "./account_open.vue?vue&type=script&lang=js&"
export * from "./account_open.vue?vue&type=script&lang=js&"
import style0 from "./account_open.vue?vue&type=style&index=0&id=3af5c94f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af5c94f",
  null
  
)

export default component.exports